export default __webpack_public_path__ + "static/media/Enterprise_HTB.4d048f6b.md";